import { renderModal } from 'helpers/modal-render';

import Icons from 'assets/icons';

interface InsightActionMenuItem {
  label: string;
  icon: React.ReactNode;
  isDelete?: boolean;
  onClick: () => void;
}

interface GetInsightDetailsActionMenuItemsArgs {
  insightName?: string;
  onDelete: () => void | Promise<void>;
  canDelete?: boolean;
}

export const getInsightDetailsActionMenuItems = ({
  insightName = '',
  onDelete,
  canDelete = false,
}: GetInsightDetailsActionMenuItemsArgs): InsightActionMenuItem[] =>
  (
    [
      canDelete && {
        label: 'Delete',
        icon: <Icons.Delete customClass="text-critical-500 mr-2" />,
        isDelete: true,

        onClick: () =>
          renderModal({
            headerText: 'Delete Insight',
            text: `Are you sure you want to delete "${insightName}"? This action cannot be undone.`,
            onConfirmCallback: onDelete,
            onConfirmButtonLabel: 'Delete',
          }),
      },
    ] as Array<InsightActionMenuItem | false>
  ).filter((item): item is InsightActionMenuItem => Boolean(item));
